module.exports = __webpack_public_path__ + "static/instagram-e323a1c490acd8ad3f84d1d1a6d78c9a.png";